<template>
  <section class="is-flex">
    <FormMultiSelect
      v-model="filter.operator"
      :config="customQueryOperatorConfig"
      :rules="{ required: true }"
      :show-float-label="false"
      @select="onQueryOperatorSelect"
      :data-e2e="TableCypressAttribute.filter.inputs.OPERATORS"
    />
    <FormMultiSelect
      v-if="tableFilter.operator && showValueSelect"
      v-model="value"
      :config="tableFilter.customTableFilter.config"
      :placeholder="$t('core.5da69a1f-b0e3-4098-9013-db341a5f23a7')"
      :rules="{ required: true }"
      :show-float-label="false"
      :form-multi-select-id="valueFormSelectId"
      class="value-select m-l-10"
      @select="onValueSelect"
      @clear="onValueSelect"
      @remove="onValueSelect"
      @options-loaded="onOptionsPopulated"
      :data-e2e="TableCypressAttribute.filter.inputs.VALUE_FORM_SELECT"
    >
      <template #option="{ option }">
        {{ option[label] }}
      </template>
    </FormMultiSelect>
  </section>
</template>

<script>
import FormMultiSelect from '/@/modules/core/form/components/FormMultiSelect.vue';
import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { TableCypressAttribute } from '/@/modules/core/table/constants/TableCypressAttribute';
import { CustomTableFilterMixin } from '/@/modules/core/table/mixins/CustomTableFilterMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CustomTableFilter',
  mixins: [CustomTableFilterMixin],
  components: { FormMultiSelect },
  static: {
    TableCypressAttribute,
    valueFormSelectId: 'custom-table-filter-value-form-select'
  },
  data() {
    return {
      customQueryOperatorConfig: new FormSelectConfig({
        options: this.tableFilter.customTableFilter.operators
      }),
      label: this.tableFilter.customTableFilter.config.label
    };
  }
};
</script>
